// noinspection DuplicatedCode

import React, { Component } from 'react';
import { FieldLabel, Text } from 'common-components/typography';
import { PrimaryButton } from 'common-components/buttons';
import { Avatar } from 'antd';
import _ from 'lodash';
import moment from 'moment-timezone';
import { dispatch, IRootDispatch, IRootState } from 'stores/rematch/root-store';
import { connect } from 'react-redux';
import { Spinner } from '@blueprintjs/core';
import { ISession } from 'interfaces/session-interfaces';
import { Stack } from '@good/ui/core';
import { IRosterShift } from '../types';

interface RemoveWorkerGroupInlineProps {
  shiftSlot: IRosterShift & { firstName?: string; lastName?: string; attachmentUrl?: string };
  onRemoved: (refreshData: boolean) => void;
  doRemoveShiftSlot: typeof dispatch.groupServiceStore.doRemoveShiftSlot;
  session: ISession;
}

interface RemoveWorkerGroupInlineState {
  step: number;
  canManuallyClose: boolean;
  refreshShiftSlots: boolean;
}

class RemoveWorkerGroupInline extends Component<RemoveWorkerGroupInlineProps, RemoveWorkerGroupInlineState> {
  override state = { step: 1, canManuallyClose: true, refreshShiftSlots: false };

  reset = () => this.setState({ step: 1, canManuallyClose: true, refreshShiftSlots: false });

  onRemoveTeamMember = async () => {
    const { doRemoveShiftSlot, session, shiftSlot } = this.props;
    const { serviceDateTimeId, serviceId } = session;
    const { supportWorkerAttendanceId } = shiftSlot;
    this.setState({ step: 2, canManuallyClose: false });
    const request = {
      serviceDateTimeId,
      serviceId,
      supportWorkerAttendanceIds: [supportWorkerAttendanceId],
      isRemoveTeamMemberOnly: true,
    };

    await doRemoveShiftSlot(request);
    await this.props.onRemoved(true);
    this.setState({ step: 3, canManuallyClose: true, refreshShiftSlots: true });
  };

  override render() {
    const { shiftSlot, session } = this.props;
    const { timezone } = session;

    if (_.isEmpty(shiftSlot)) {
      return <></>;
    }
    const { shiftStartDateTime, shiftEndDateTime } = shiftSlot;

    const dateDisplay =
      `${moment.tz(shiftStartDateTime, timezone).format('hh:mm A')}` +
      `- ${moment.tz(shiftEndDateTime, timezone).format('hh:mm A, Do MMMM YYYY')}`;
    const workerFullName = `${shiftSlot.firstName || ''} ${shiftSlot.lastName || ''}`;

    return (
      <>
        {this.state.step === 1 && (
          <Stack align='center'>
            <div className='mb-medium'>
              <Text>You are removing a team member from the following shift : </Text>
            </div>

            <div className='line-height-135 mb-medium'>
              <FieldLabel text={'SHIFT TIME'} />
              <Text lineHeight={135}>{dateDisplay}</Text>
            </div>

            <div className='line-height-135 mb-large'>
              <FieldLabel text={'TEAM MEMBER TO REMOVE'} />
              <div className='flex-row line-height-135 align-center mt-x2-small'>
                <Avatar icon='user' src={shiftSlot.attachmentUrl} className='mr-small' />
                <Text lineHeight={135}>{workerFullName}</Text>
              </div>
            </div>
            <PrimaryButton size='large' onClick={this.onRemoveTeamMember}>
              Remove team member
            </PrimaryButton>
          </Stack>
        )}

        {this.state.step === 2 && (
          <div className='line-height-135 anim-slide-left'>
            <div className='flex-column align-center mv-large justify-center'>
              <div className='mb-medium'>
                <Spinner size={80} />
              </div>
              <div className='text-align-center'>
                <Text color='secondary' weight='bold'>
                  Removing team member and updating shift...
                </Text>
                <br />
                <Text color='secondary'>This won't take long.</Text>
              </div>
            </div>
          </div>
        )}

        {this.state.step === 3 && (
          <div className='anim-fade-in-fast'>
            <div className='mb-medium'>
              <Text>
                You have successfully removed <b>{workerFullName}</b> from the following shift :
              </Text>
            </div>

            <div className='line-height-135 mb-medium'>
              <FieldLabel text={'SHIFT TIME'} />
              <Text lineHeight={135}>{dateDisplay}</Text>
            </div>

            <div className='line-height-135 mb-large'>
              <FieldLabel text={'REMOVED TEAM MEMBER'} />
              <div className='flex-row line-height-135 align-center mt-x2-small'>
                <Avatar icon='user' src={shiftSlot.attachmentUrl} className='mr-small' />
                <Text lineHeight={135}>{workerFullName}</Text>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapState = (_state: IRootState) => ({});

const mapDispatch = (dispatch: IRootDispatch) => ({
  doRemoveShiftSlot: dispatch.groupServiceStore.doRemoveShiftSlot,
});

export default connect(mapState, mapDispatch)(RemoveWorkerGroupInline);
